__turbopack_context__.v({
  "blueskyIcon": "i98dNa_blueskyIcon",
  "copyIcon": "i98dNa_copyIcon",
  "facebookIcon": "i98dNa_facebookIcon",
  "linkIcon": "i98dNa_linkIcon",
  "redditIcon": "i98dNa_redditIcon",
  "shareContainer": "i98dNa_shareContainer",
  "shareNetwork": "i98dNa_shareNetwork",
});
